// Create a jest file for the PricingCard component.

import React from 'react'
import { render, screen } from '@testing-library/react'
import PricingCard from '../PricingCard'
import { PricingCardProps } from '../types.d'

const baseProps: PricingCardProps = {
  bgColor: 'bg-gray-0',
  ctaLabel: 'Test CTA Label',
  ctaLink: 'https://www.toasttab.com',
  sectionDescription: 'Test Description',
  sectionHeading: 'Test Title',
  padding: '24',
  packagePrice: '$100'
}

describe('PricingCard UI Tests', () => {
  it('Should display PricingCard', () => {
    render(<PricingCard {...baseProps} />)
    expect(screen.getByTestId('PricingCard-1')).toBeTruthy()
  })

  it('Should display PricingCard with a heading', () => {
    render(<PricingCard {...baseProps} />)
    expect(screen.getByText('Test Title')).toBeTruthy()
  })

  it('Should display PricingCard with a description', () => {
    render(<PricingCard {...baseProps} />)
    expect(screen.getByText('Test Description')).toBeTruthy()
  })

  it('Should display PricingCard with a price', () => {
    render(<PricingCard {...baseProps} pricePrefix='$' priceSuffix='/mo' />)
    expect(screen.getByText('$100')).toBeTruthy()
  })

  it('Should display PricingCard with a pricePrefix', () => {
    render(
      <PricingCard {...baseProps} pricePrefix='As low as' priceSuffix='/mo' />
    )
    expect(screen.getByText('As low as')).toBeTruthy()
  })

  it('Should display PricingCard with a priceSuffix', () => {
    render(
      <PricingCard {...baseProps} pricePrefix='As low as' priceSuffix='2.99%' />
    )
    expect(screen.getByText('2.99%')).toBeTruthy()
  })

  it('Should display PricingCard with a packagePriceMonthly', () => {
    render(
      <PricingCard
        {...baseProps}
        pricePrefix='As low as'
        priceSuffix='2.99%'
        packagePriceMonthly='/month'
      />
    )
    expect(screen.getByText('/month')).toBeTruthy()
  })

  it('Should display PricingCard with a badgeText and badgeColor', () => {
    render(
      <PricingCard {...baseProps} badgeText='top' badgeColor='bg-lavender-0' />
    )
    expect(screen.getByText('top')).toBeTruthy()
  })

  it('Should display PricingCard with a ctaLabel and ctaLink', () => {
    render(<PricingCard {...baseProps} />)
    expect(screen.getByText('Test CTA Label')).toBeTruthy()
  })

  it('Should display PricingCard with accentPosition top', () => {
    render(
      <PricingCard {...baseProps} accentColor='blue-75' accentPosition='top' />
    )
    expect(screen.getByTestId('PricingCard-accent--top')).toBeTruthy()
  })

  it('Should display PricingCard with a accentColor and accentPosition bottom', () => {
    render(
      <PricingCard
        {...baseProps}
        accentColor='blue-75'
        accentPosition='bottom'
      />
    )
    expect(screen.getByTestId('PricingCard-accent--bottom')).toBeTruthy()
  })

  it('Should display PricingCard with the correct accentColor', () => {
    render(
      <PricingCard {...baseProps} accentColor='blue-75' accentPosition='top' />
    )
    expect(screen.getByTestId('PricingCard-accent--top')).toHaveClass(
      'before:bg-blue-75'
    )
  })

  it('Should display PricingCard with a styledList', () => {
    render(
      <PricingCard
        {...baseProps}
        children={[
          {
            sectionHeading: 'heading',
            sectionDescription: 'description',
            listStyles: 'list-plus-circle-gray',
            listItems: [
              { col1: 'Lorem ipsum 1', col2: 'Lorem ipsum dolor sit amet' },
              { col1: 'Lorem ipsum 2', col2: 'Lorem ipsum dolor sit amet' },
              { col1: 'Lorem ipsum 3', col2: 'Lorem ipsum dolor sit amet' }
            ]
          }
        ]}
      />
    )
    expect(screen.getByText('Lorem ipsum 1')).toBeTruthy()
  })

  it('Should display PricingCard with a textAlignment center', () => {
    render(<PricingCard {...baseProps} textAlignment='center' />)
    expect(screen.getByTestId('PricingCard-inner')).toHaveClass('text-center')
  })
})
